// extracted by mini-css-extract-plugin
export default {"deleteLinkedAccount":"page_deleteLinkedAccount__6I4MH","social":"page_social__wzBKQ","socialButtons":"page_socialButtons__1XKtx","businessEmail":"page_businessEmail__WKZjX"};